<template>
  <section class="quote-row-section">
    <v-container>
      <h2 v-if="title" class="font-sora quote-row__title">{{ title }}</h2>
      <div class="quote-row" :class="'quote-row--' + quotes.length">
        <quote-block
          v-for="(item, i) in quotes"
          :key="i"
          :quote="item.quote"
          :attribution="item.attribution"
          :role="item.role || ''"
          :eyebrow="item.eyebrow || ''"
          :compact="quotes.length > 1"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import QuoteBlock from '@/components/marketing/QuoteBlock.vue';

/**
 * One, two or three testimonials side by side, stacking on narrow screens.
 *
 * Several pages carry a main quote plus a supporting one, and since the
 * Trilogy Active quotes (16 Sep 2026) a few carry three from different
 * customers. Side by side rather than stacked keeps them reading as a set
 * rather than as competing claims.
 */
export default {
  name: 'QuoteRow',
  components: { QuoteBlock },
  props: {
    quotes: {
      type: Array,
      required: true,
      validator: (v) => v.length > 0 && v.length <= 3,
    },
    title: { type: String, default: '' },
  },
};
</script>

<style scoped>
.quote-row-section {
  padding: 8px 0 16px;
}

.quote-row__title {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px;
}

.quote-row {
  display: grid;
  gap: 16px;
  margin: 0 auto;
}

.quote-row--1 {
  max-width: 680px;
}

.quote-row--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 980px;
}

.quote-row--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-width: 1180px;
}

@media (max-width: 1099px) {
  .quote-row--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 980px;
  }
}

@media (max-width: 899px) {
  .quote-row--2,
  .quote-row--3 {
    grid-template-columns: minmax(0, 1fr);
    max-width: 680px;
  }
}
</style>
